/**
 * <CancelSummaryCard> — le récapitulatif des deux dernières étapes de la résiliation (molecule).
 *
 * Motif, fin d'abonnement, frais, à régler maintenant — puis, une fois que c'est fait, fin
 * d'accès, frais débités, reçu envoyé à. Une seule carte pour les deux écrans : c'est la même
 * table, lue avant puis après.
 *
 * La carte reste blanche : la lavande est déjà celle du moyen de paiement juste en dessous, et
 * deux aplats identiques ne distinguent plus rien.
 *
 * Composition de `<Card>` + `<SummaryRow>` ; le filet ne se pose qu'avant la ligne de total,
 * comme le veut `<SummaryRow>`. Les valeurs arrivent écrites — aucun montant, aucune date n'est
 * calculée ici.
 */
import React from "react"

import { type UICancelSummaryRow } from "../../../ports/primary/ui/types"
import { Divider } from "../../atoms/Divider"
import { Stack } from "../../atoms/containers/Stack"
import { Card } from "../Card"
import { SummaryRow } from "../SummaryRow"

export type CancelSummaryCardProps = {
    rows: UICancelSummaryRow[]
    testID?: string
}

export function CancelSummaryCard(props: CancelSummaryCardProps) {
    const { rows, testID } = props

    if (rows.length === 0) return null

    // Le filet sépare le total du reste — une fois, avant la première ligne mise en avant.
    const firstEmphasisIndex = rows.findIndex((row) => row.emphasis === true)

    return (
        <Card testID={testID} p="3">
            <Stack gap="2">
                {rows.map((row, index) => (
                    <React.Fragment key={row.label}>
                        {index === firstEmphasisIndex && index > 0 && <Divider spacing="0" />}
                        <SummaryRow label={row.label} value={row.value} emphasis={row.emphasis} />
                    </React.Fragment>
                ))}
            </Stack>
        </Card>
    )
}
